const path = "/pedagogico/avaliacao-institucional";
export default {
  validarUsuario: `${path}/validar`,
  questionariosServidores: `${path}/questionarios-servidores`,
  instituicaoHabilitadas: (id_processo) => `${path}/instituicao-habilitada/${id_processo}`,
  responderAdministrativo: `${path}/responder-administrativo`,
  respondidasAdministrativo: (id) => `${path}/respondidas-administrativo/${id}`,
};
